import { render } from "./TimerButtons.vue?vue&type=template&id=6d6c5413"
import script from "./TimerButtons.vue?vue&type=script&lang=js"
export * from "./TimerButtons.vue?vue&type=script&lang=js"

import "./TimerButtons.vue?vue&type=style&index=0&id=6d6c5413&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__